import { createUpdatableContext } from "fe-web-components/context/context";
import { ClinicStateData } from "fe-common/graphql/clinic/clinicTypes";

export const [ClinicProvider, useClinicState] = createUpdatableContext<
  ClinicStateData
>(null, () => null);
